import { render, staticRenderFns } from "./ScatterGraph.vue?vue&type=template&id=67ff029a&"
import script from "./ScatterGraph.vue?vue&type=script&lang=js&"
export * from "./ScatterGraph.vue?vue&type=script&lang=js&"
import style0 from "./ScatterGraph.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports